import CustomLink, { CustomLinkProps } from 'components/shared/CustomLink';
import React, { forwardRef } from 'react';
import styles from './styleConstants.module.css';

export const PrimaryLink = forwardRef<HTMLAnchorElement, CustomLinkProps>(
  function PrimaryLink({ className, ...props }, ref) {
    return (
      <CustomLink
        ref={ref}
        className={`${styles.primaryCta}${className ? ` ${className}` : ''}`}
        {...props}
      />
    );
  },
);

export const PrimaryButton = forwardRef<
  HTMLButtonElement,
  React.ButtonHTMLAttributes<HTMLButtonElement>
>(function PrimaryButton({ className, ...props }, ref) {
  return (
    <button
      ref={ref}
      className={`${styles.primaryCta}${className ? ` ${className}` : ''}`}
      {...props}
    />
  );
});
